import React from 'react';
import './Footer.css';
import logo from '../../assets/logo.png';
import { Link as ScrollLink, scroller } from 'react-scroll';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaWhatsapp } from "react-icons/fa";


const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isNotHomePage = location.pathname !== '/';
  const isContactPage = location.pathname === '/contact';
  const isAboutPage = location.pathname === '/aboutPage';


  const handleNavClick = (to) => {
    if (to === 'contact') {
      navigate('/contact');
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); // 👈 scroll to top
    } else if (to === 'about') {
      navigate('/aboutPage');
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); // 👈 scroll to top
    } else if (isContactPage || isAboutPage) {
      navigate('/');
      setTimeout(() => {
        scroller.scrollTo(to, {
          duration: 800,
          delay: 0,
          smooth: 'easeInOutQuart'
        });
      }, 100); // Delay to ensure HomePage loads
    } else {
      scroller.scrollTo(to, {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart'
      });
    }
  };


  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-section">
          <img src={logo} alt="Vedant Logo" className="footer-logo" />
          <p>
            At Vedant, we specialize in high-quality industrial components and
            efficient logistics services, ensuring timely and reliable support
            across sectors.
          </p>
        </div>

        <div className="footer-section">
          <h4>NAVIGATION</h4>
          <ul>
            <li onClick={() => handleNavClick('home')}>Home</li>
            <li onClick={() => handleNavClick('about')}>About Us</li>
            <li onClick={() => handleNavClick('services')}>Services</li>
            <li onClick={() => handleNavClick('howitworks')}>How it Works</li>
            <li onClick={() => handleNavClick('testimonials')}>Testimonials</li>
            <li onClick={() => handleNavClick('contact')}>Contact Us</li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>CONTACT US</h4>
          <p>
            <a href="mailto:contactus@vedantenterprisesglb.com">
              contactus@vedantenterprisesglb.com
            </a>
          </p>
          <p>Kalaburagi, Pallapur, <br />Karnataka 585101</p>
          <div className="whatsapp">
            <a href="https://api.whatsapp.com/send?phone=918310427583" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp />
            </a>
          </div>
        </div>
        <div className="footer-section">
          <div className="footer-map">
            <iframe
              title="Vedant Enterprises Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3807.778995381813!2d76.7948979!3d17.374364399999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc8b94e37203169%3A0xe7b9acd53e0ad0d2!2sVEDANT%20ENTERPRISES!5e0!3m2!1sen!2sin!4v1749130984565!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>COPYRIGHT © 2025 VEDANT ENTERPRISES</p>
        <a href="https://www.belageri.com" target="_blank" rel="noopener noreferrer">
          <p>DESIGNED BY BELAGERI TECHNOLOGIES</p></a>

      </div>
    </footer>
  );
};

export default Footer;
